var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { createRef } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { ApplicationContext } from '../../../ApplicationContext';
import CreateReportCommand from "../../../commands/reports/CreateReportCommand";
import { FormErrorContext } from "../../../FormErrorContext";
import { ReportDataType } from "../../../data/ReportDataType";
import ReportDateRange from "./ReportDateRange";
import ReportFilterLookup from "./ReportFilterLookup";
import ReportInterval from "./ReportInterval";
import ReportTimezone from "./ReportTimezone";
import ReportParameterModel from "../../../models/ReportParameterModel";
import Signals from "../../../signals/Signals";
import { toCSV, toXLSX } from "../../../utils/exportUtils";
import { ExportButton } from "../../components/ui/ExportButton/ExportButton";
var ReportValueSettings = /** @class */ (function (_super) {
    __extends(ReportValueSettings, _super);
    /**
     *
     */
    function ReportValueSettings(props) {
        var _this = _super.call(this, props) || this;
        _this.formRef = createRef();
        _this.state = {
            reportParameters: []
        };
        _this.onRunReport = _this.onRunReport.bind(_this);
        return _this;
    }
    /**
     *
     * @returns {*}
     */
    ReportValueSettings.prototype.render = function () {
        var _a = this.props, reportModel = _a.reportModel, reportDataModel = _a.reportDataModel, intl = _a.intl;
        var _b = this.state, errors = _b.errors, reportParameters = _b.reportParameters;
        // Date range
        return [
            React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                React.createElement("form", { ref: this.formRef, onSubmit: this.onRunReport },
                    reportModel.parameterInfos.map(function (reportParameterInfoModel, index) {
                        if (!reportParameters[index]) {
                            reportParameters[index] = new ReportParameterModel({
                                parameterId: reportParameterInfoModel.parameterId,
                                parameterType: reportParameterInfoModel.type
                            });
                        }
                        var reportParameter = reportParameters[index];
                        switch (reportParameterInfoModel.type) {
                            case ReportDataType.DATE_RANGE:
                                return React.createElement(ReportDateRange, { key: reportParameterInfoModel.parameterId + '-' + index, reportModel: reportModel, reportParameterInfoModel: reportParameterInfoModel, reportParameterModel: reportParameter });
                            case ReportDataType.TIME_INTERVAL:
                                return React.createElement(ReportInterval, { key: reportParameterInfoModel.parameterId + '-' + index, reportModel: reportModel, reportParameterInfoModel: reportParameterInfoModel, reportParameterModel: reportParameter });
                            case ReportDataType.TIMEZONE:
                                return React.createElement(ReportTimezone, { key: reportParameterInfoModel.parameterId + '-' + index, reportModel: reportModel, reportParameterInfoModel: reportParameterInfoModel, reportParameterModel: reportParameter });
                            case ReportDataType.FILTER_LOOKUP:
                                return React.createElement(ReportFilterLookup, { key: reportParameterInfoModel.parameterId + '-' + index, reportModel: reportModel, reportParameterInfoModel: reportParameterInfoModel, reportParameterModel: reportParameter });
                        }
                        return null;
                    }),
                    React.createElement(Row, null,
                        React.createElement(Col, { className: "d-flex justify-content-between align-items-start button-grid", sm: 12 },
                            React.createElement("button", { type: "submit", className: "btn btn-primary", onClick: this.onRunReport },
                                React.createElement(FormattedMessage, { id: "reports.settings.form.submit" })),
                            reportDataModel.data.length > 0 &&
                                React.createElement(ExportButton, { onClick: function (event, type) {
                                        switch (type) {
                                            case 'csv':
                                                toCSV(reportDataModel.getExportData(reportModel, intl), reportModel.id);
                                                break;
                                            case 'xlsx':
                                                toXLSX(reportDataModel.getExportData(reportModel, intl), reportModel.id);
                                                break;
                                        }
                                    } })))))
        ];
    };
    ReportValueSettings.prototype.onRunReport = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var _a = this.props, reportModel = _a.reportModel, reportDataModel = _a.reportDataModel;
        var reportParameters = this.state.reportParameters;
        var command = new CreateReportCommand();
        command.execute(session.user.organisation.id, reportModel.id, reportParameters).then(function (response) {
            reportDataModel.update(response);
        }).catch(function (error) {
            Signals.ShowNotification.dispatch('Er is iets misgegaan: ' + error, 'danger');
        });
    };
    ReportValueSettings = __decorate([
        observer
    ], ReportValueSettings);
    return ReportValueSettings;
}(React.Component));
ReportValueSettings.contextType = ApplicationContext;
export default injectIntl(ReportValueSettings);
